import React, { useState } from 'react';
import { FormControl, InputLabel, IconButton, Input, InputAdornment, TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import { useDispatch } from 'react-redux';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import MuiAlert from '@material-ui/lab/Alert';
import api from '../api';
import CustomTextField from '../components/customTextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import NumberFormat from 'react-number-format';
import { Visibility, VisibilityOff } from '@material-ui/icons';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="Rp. "
        />
    );
}

export default function EditMasterSpesialis(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [id, setID] = React.useState("")
    const [nama, setNama] = useState("")
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [errorNama, setErrorNama] = React.useState(false);
    const [texterrorNama, setTextErrorNama] = React.useState(null);
    const [visibleConfirm, setVisibleConfirm] = React.useState(false);


    const forceUpdate = React.useReducer(bool => !bool)[1];

    React.useEffect(() => {
        getDetailMasterSpesialis()
    }, [])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const getDetailMasterSpesialis = (cat) => {
        api.create().getDetailMasterSpesialis(props.id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setID(data.id)
                    setNama(data.name)
                }
            }
        })
    }

    const doSubmit = (e) => {
        if (nama === "") {
            setErrorNama(true)
            setTextErrorNama("Nama Spesialisasi wajib diisi")
        } else {
            let payload = {
                "id": id,
                "name": nama,
            }
            console.log(payload);
            api.create().updateMasterSpesialis(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.message)
                        setStatusAlert("Success")
                        props.onClose()
                        // props.refresh()
                        props.getData()
                    } else {
                        if (response.data.data) {
                            setOpenAlert(true)
                            setMessageAlert(response.data.data)
                            setStatusAlert("Warning")
                        }
                    }
                }
            })
        }
    }

    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Edit Master Spesialisasi Telemedicine</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '20px 50px' }}>
                    <div className="column-1">
                        <div>
                            <CustomTextField
                                required={true}
                                label={'Nama Spesialisasi'}
                                value={nama}
                                error={errorNama}
                                helperText={texterrorNama}
                                onChange={(val) => {
                                    setNama(val)
                                    setErrorNama(false)
                                    setTextErrorNama("")
                                    forceUpdate()
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => doSubmit()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>

            {visibleConfirm && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisibleConfirm(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>Reservasi yang sudah terbuat dari jadwal tersebut akan dibatalkan secara otomatis. Apakah anda ingin melanjutkan pembuatan jadwal libur nasional?</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisibleConfirm(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => null
                                        // doSubmit()
                                    }
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }
        </div>
    )
}